import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import "./i18n"
import { Provider } from "react-redux"
import "./index.css"
import "./banner-supplier.css"
import "./print.css"
import store from "./store/store"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <React.Fragment>
        <BrowserRouter
          future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
        >
          <App />
        </BrowserRouter>
      </React.Fragment>
    </HelmetProvider>
  </Provider>
)

serviceWorker.unregister()
